import React from "react";

import ApiButton from "../../../shared/ui/Api.Button";
import {
  MonthsDropdown,
  YearsDropdown,
} from "../../invoices/components/Invoices.Component";

const TaxReportsInternal = ({
  year,
  changeYear,
  month,
  changeMonth,
  fetching,
  fetched,
  error,
  getReport,
}) => {
  return (
    <React.Fragment>
      <div>
        <YearsDropdown year={year} setYear={changeYear} />
        <MonthsDropdown month={month} setMonth={changeMonth} />
      </div>
      <div>
        <ApiButton
          sending={fetching}
          sent={fetched}
          error={error}
          buttonLabel={"Fetch Tax Reports"}
          onButtonClick={getReport}
        />
      </div>
    </React.Fragment>
  );
};

export default TaxReportsInternal;
